const STORAGE_KEY = "token";
const AUTH_INFO_KEY = "authInfo";

export interface AuthInfo {
	name: string;
	displayName: string;
	isAdmin: boolean;
}

export const storeToken = (token: string) => {
	sessionStorage.setItem(STORAGE_KEY, token);
};

export const retrieveToken = (): string => {
	return sessionStorage.getItem(STORAGE_KEY);
};

export const getAuthInfo = (): AuthInfo => {
	try {
		return JSON.parse(sessionStorage.getItem(AUTH_INFO_KEY));
	} catch (e) {
		console.error("Unable to get auth info: ", e);

		return {
			name: "Invalid name",
			displayName: "Invalid name",
			isAdmin: false
		};
	}
};
